<template>
  <div class="console-app">
    <p>
      ScrollTop: {{ scrolltop }}
    </p>
    <p>
      Width: {{ documentWidth }}
    </p>
    <p>
      Loading State: Loaded
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      scrolltop: 0,
      documentWidth: 0
    }
  },
  methods: {
    updateScrollTop () {
      this.scrolltop = document.documentElement.scrollTop
    },
    upadateWidth () {
      this.documentWidth = window.innerWidth
    }
  },
  mounted () {
    this.updateScrollTop()
    this.upadateWidth()
    document.addEventListener('scroll', this.updateScrollTop)
    window.addEventListener('resize', this.upadateWidth)
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.updateScrollTop)
    window.removeEventListener('resize', this.upadateWidth)
  }
}
</script>

<style lang="scss" scoped>
  .console-app {
    text-align: left;
    opacity: 0.6;
    min-height: 100px;
    position: fixed;
    z-index: 10000;
    margin: 0.5em;
    padding: 0.5em;
    bottom: 0;
    left: 0;
    width: calc(100% - 1em);
    width: auto;
    border: 1px solid rgb(46, 46, 46);
    background: rgb(68, 68, 68);
  }
</style>



// WEBPACK FOOTER //
// src/components/Console.vue